import { localDate } from '@/platform/lib/utils';
import {
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '@/platform/ui';

const EmploymentsPopup = ({ entitlement }) => (
    <Tooltip>
        <TooltipTrigger>
            {localDate(entitlement.employment_start_date)}
        </TooltipTrigger>
        <TooltipContent>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell colSpan={3}>
                            Dienstverbanden
                        </TableHeaderCell>
                    </TableRow>
                    <TableRow>
                        <TableHeaderCell>Pers.nr.</TableHeaderCell>
                        <TableHeaderCell>Ind.</TableHeaderCell>
                        <TableHeaderCell textAlign='right'>
                            Uit.
                        </TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {entitlement?.overlapping_employments?.map(employment => (
                        <TableRow key={employment.id}>
                            <TableCell>{employment?.staff_number}</TableCell>
                            <TableCell>
                                {localDate(employment?.start_date)}
                            </TableCell>
                            <TableCell textAlign='right'>
                                {localDate(employment?.end_date)}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TooltipContent>
    </Tooltip>
);

export default EmploymentsPopup;
